{
  "version": 1,
  "asset_id": "e74aaca2-955c-4624-96dd-9a99095571a5",
  "project_id": "765508a6-9c9d-45ab-81ce-ecfbc5eb2942",
  "url": "/__l5e/assets-v1/e74aaca2-955c-4624-96dd-9a99095571a5/fireworks-hero.png",
  "r2_key": "a/v1/765508a6-9c9d-45ab-81ce-ecfbc5eb2942/e74aaca2-955c-4624-96dd-9a99095571a5/fireworks-hero.png",
  "original_filename": "fireworks-hero.png",
  "size": 262408,
  "content_type": "image/webp",
  "created_at": "2026-08-18T19:40:17Z"
}
